<template>
    <div class="col-xs-6 col-sm-4 col-md-3">
        <div class="thumb m-t-15" v-pml-block="isLoading">
            <button class="btn btn-xs btn-danger" @click.prevent="askToDelete()" v-if="deal.editable" v-pml-tooltip.left="$t('delete')"><i class="fa fa-times"></i></button>
            <a :href="item.full_url" class="link_icon relative" :target="setBlank()">
                <span class="custom_label_size_archive">{{ item.size | pmlBytesConversion }}</span>
                <i :class="getIcon()"></i>
            </a>
            <input type="text" class="form-control m-t-10 t_overflow" v-model="name" :disabled="!deal.editable" @change="nameUpdate()" />
        </div>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { mapGetters } from 'vuex'
    import { trans } from 'utils/helpers/translation'
    import { update, destroy } from 'services/attachments'
    import { askToDelete } from 'utils/helpers/sweet-alert'

    export default {
        name: 'AttachmentItem',
        props: [ 'item' ],
        data () {
            return {
                showForm: false,
                isLoading: false,
                name: ''
            }
        },
        created () {
            this.name = this.item.name
        },
        computed: {
            ...mapGetters({
                'deal': 'getDealInfo'
            })
        },
        watch: {
            item () {
                this.name = this.item.name
            }
        },
        methods: {
            askToDelete () {
                askToDelete()
                    .then((response) => (response.value) ? this.delete() : null)
            },
            delete () {
                this.isLoading = true

                destroy(this.item.id, this.item.deal_id)
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            nameUpdate () {
                this.isLoading = true

                update(this.item.id, this.item.deal_id, { name: this.name })
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            setBlank () {
                return (this.item.type === 'image' || this.item.type === 'pdf') ? '_blank' : '_self'
            },
            getIcon () {
                if (this.item.type === 'document') return 'icon-docs'
                if (this.item.type === 'image') return 'icon-picture'
                if (this.item.type === 'pdf') return 'icon-lock'
                if (this.item.type === 'compressed') return 'icon-layers'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/attachments/Item.vue